import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/ae/banner_back.webp";
import { StaticImage } from "gatsby-plugin-image";

function Banner() {
  return (
    <div
      className="locationgcc_banner no-bread-loc-banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>
                  Pioneering Digital Transformation Solutions in the Dubai
                </h1>
              </div>
              <p className="main_para">
                TekRevol leads the charge toward digital excellence as a
                frontrunner in the industry. We specialize in innovating
                revolutionary web and mobile experiences within the GCC region,
                propelling the advancement of digital evolution.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                 Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center"
          >
            <StaticImage
              src="../../../images/locationgcc/dxb/ae/banner_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={899}
              height={872}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
